import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CpcGroupByKey, Filters, GeneralGroupByKey, StatisticsSort } from './types';

export interface StatisticsState {
  filters: Filters;
  generalGroupBy: GeneralGroupByKey;
  cpcGroupBy: CpcGroupByKey;
  sort: StatisticsSort | null;
}

const initialState: StatisticsState = {
  filters: {
    dateFrom: '',
    dateTo: '',
    operators: [],
    platforms: [],
    sources: [],
    landings: [],
    streams: [],
    label1: '',
    label2: '',
    referrer: '',
    subscription: 'subscription_period',
    transactions: '',
    currency_id: 1,
  },
  generalGroupBy: 'dates',
  cpcGroupBy: 'dates',
  sort: null,
};

const statisticsSlice = createSlice({
  name: 'statistics',
  initialState,
  reducers: {
    setFilter: (
      state,
      action: PayloadAction<{ key: keyof Filters; value: Filters[keyof Filters] }>
    ) => {
      const { key, value } = action.payload;
      if (key === 'operators' || key === 'landings') {
        (state.filters[key] as Array<string | number>) = Array.isArray(value) ? value : [value];
      } else {
        (state.filters[key] as string | string[]) = value as string | string[];
      }
    },
    setGeneralGroupBy: (state, action: PayloadAction<GeneralGroupByKey>) => {
      state.generalGroupBy = action.payload;
    },
    setCpcGroupBy: (state, action: PayloadAction<CpcGroupByKey>) => {
      state.cpcGroupBy = action.payload;
    },
    resetFilter: (state, action: PayloadAction<keyof Filters>) => {
      const key = action.payload;
      const defaultValue = initialState.filters[key];
      if (key === 'operators' || key === 'landings') {
        (state.filters[key] as Array<string | number>) = Array.isArray(defaultValue)
          ? defaultValue
          : [];
      } else {
        (state.filters[key] as string | string[]) = defaultValue as string | string[];
      }
    },
    setSort: (state, action: PayloadAction<StatisticsSort>) => {
      state.sort = action.payload;
    },
    resetSort: (state) => {
      state.sort = initialState.sort;
    },
    resetAll: () => initialState,
  },
});

export const {
  setFilter,
  setGeneralGroupBy,
  setCpcGroupBy,
  resetFilter,
  setSort,
  resetSort,
  resetAll,
} = statisticsSlice.actions;
export default statisticsSlice.reducer;
